import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../shared';


/**
 * Base component for plat instrument tables.
 */
@Component({
	selector: 'plat-instrument-tables',
	templateUrl: './plat-instrument-tables.component.html',	changeDetection: ChangeDetectionStrategy.Eager

})
export class PlatInstrumentTablesComponent extends BaseComponent implements OnInit {

	is3mm = false;
	is3dot5mm = false;
	is5mm = false;
	title?: string;
	titleColor?: string;
	titleBackColor?: string;


	ngOnInit(): void {
		const screwDiameter = this.canvasSrv.plate?.size;
		switch (screwDiameter) {
			case 3:
				this.title = this.labels()['JPS_3.0MM_INST_TRAY'];
				this.is3mm = true;
				this.titleColor = 'white';
				this.titleBackColor = '#196C3D';
				break;
			case 3.5:
				this.title = this.labels()['JPS_3.5MM_INST_TRAY'];
				this.is3dot5mm = true;
				this.titleColor = 'black';
				this.titleBackColor = '#FCC026';
				break;
			case 5:
				this.title = this.labels()['JPS_5.0MM_INST_TRAY'];
				this.is5mm = true;
				this.titleColor = 'white';
				this.titleBackColor = '#1D3D7A';
				break;
		}
	}

}
